import { PackageVariantPlusIcon } from './PackageVariantPlusIcon';

/**
 * author: Michael Irigoyen
 * id 8E0543FE-6EC4-4D0F-9109-E77254414DD7
 * name package-variant-plus
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-variant-plus.svg
 * tags
 */
export const BoxVariantPlusIcon = PackageVariantPlusIcon;
export default BoxVariantPlusIcon